import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { SearchTriggerType } from '../../../stats/types';
import { SearchActionType } from '../types';

export class GtmStatsAdapterSearchAction implements StatsAdapterInterface {
  /**
   * Mapping SearchTriggerType to SearchActionType
   */
  private mapping: { [key: string]: SearchActionType } = {
    initial: 'Initial',
    update: 'Refine',
    reset: 'Reset',
  };

  /**
   *
   * @param searchTrigger
   */
  constructor(protected searchTrigger: SearchTriggerType) {}

  /**
   * @inheritDoc
   */
  public getData(): SearchActionType {
    // Unsupported trigger
    if (!this.mapping[this.searchTrigger]) {
      throw new Error(
        'GtmStatsAdapterSearchAction does not support "' + this.searchTrigger + '" search trigger value.'
      );
    }

    return this.mapping[this.searchTrigger];
  }
}
